import { SAVE_USER } from '../constants/actionTypes.js'

const initialState = {
  logged_in: false,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER:
      return Object.assign({}, state, action.value)
    default:
      return state
  }
}

export default userReducer
export { initialState }
